export const ATTR_FORMAT_TYPES = {
  //formats supported in detection and validation
  IPV4: 'ipv4',
  IPV6: 'ipv6',
  USER_AGENT: 'user-agent',
  DEVICE_ID: 'deviceId',
  LOCATION: 'location',
  VIN: 'vin',
  URL: 'url',
  CREDIT_CARD: 'credit-card',
  SSN: 'ssn',
  HASH: 'hash',
  TIME: 'time',
  DATE: 'date',
  TIMESTAMP: 'timestamp',
  INTEGER: 'integer',
  DECIMAL: 'decimal',

  //deprecated  temporarily
  ADDRESS: 'address',
  MD5_HASH: 'md5',
  SHA256_HASH: 'sha256',

  //Legacy Formats, keep around only for detection.
  EMAIL: 'email',
  IP: 'ip',
  EPOCH: 'epoch',
  SKU: 'sku',
  CURRENCY: 'currency',
  NUMBER: 'number',
  STRING: 'string',
  UPC: 'upc',
  QUANTITY: 'quantity',
};

export const ALL_FORMATS = {
  //formats supported in detection and validation
  [ATTR_FORMAT_TYPES.IPV4]: {
    value: ATTR_FORMAT_TYPES.IPV4,
    label: 'IP v4',
  },
  [ATTR_FORMAT_TYPES.IPV6]: {
    value: ATTR_FORMAT_TYPES.IPV6,
    label: 'IP v6',
  },

  [ATTR_FORMAT_TYPES.USER_AGENT]: {
    value: ATTR_FORMAT_TYPES.USER_AGENT,
    label: 'User Agent',
  },

  [ATTR_FORMAT_TYPES.DEVICE_ID]: {
    value: ATTR_FORMAT_TYPES.DEVICE_ID,
    label: 'Device Id',
  },

  [ATTR_FORMAT_TYPES.LOCATION]: {
    value: ATTR_FORMAT_TYPES.LOCATION,
    label: 'Location',
  },

  [ATTR_FORMAT_TYPES.VIN]: {
    value: ATTR_FORMAT_TYPES.VIN,
    label: 'VIN',
  },

  [ATTR_FORMAT_TYPES.URL]: {
    value: ATTR_FORMAT_TYPES.URL,
    label: 'URL',
  },

  [ATTR_FORMAT_TYPES.CREDIT_CARD]: {
    value: ATTR_FORMAT_TYPES.CREDIT_CARD,
    label: 'Credit Card',
  },
  [ATTR_FORMAT_TYPES.ADDRESS]: {
    value: ATTR_FORMAT_TYPES.ADDRESS,
    label: 'Address',
  },
  [ATTR_FORMAT_TYPES.SSN]: {
    value: ATTR_FORMAT_TYPES.SSN,
    label: 'SSN',
  },
  [ATTR_FORMAT_TYPES.HASH]: {
    value: ATTR_FORMAT_TYPES.HASH,
    label: 'Hash',
  },
  [ATTR_FORMAT_TYPES.MD5_HASH]: {
    value: ATTR_FORMAT_TYPES.MD5_HASH,
    label: 'Hash (MD5)',
  },
  [ATTR_FORMAT_TYPES.SHA256_HASH]: {
    value: ATTR_FORMAT_TYPES.SHA256_HASH,
    label: 'Hash (SHA256)',
  },
  [ATTR_FORMAT_TYPES.TIME]: {
    value: ATTR_FORMAT_TYPES.TIME,
    label: 'Time',
  },

  [ATTR_FORMAT_TYPES.DATE]: {
    value: ATTR_FORMAT_TYPES.DATE,
    label: 'Date',
  },
  [ATTR_FORMAT_TYPES.TIMESTAMP]: {
    value: ATTR_FORMAT_TYPES.TIMESTAMP,
    label: 'Timestamp',
  },
  [ATTR_FORMAT_TYPES.INTEGER]: {
    value: ATTR_FORMAT_TYPES.INTEGER,
    label: 'Integer',
  },
  [ATTR_FORMAT_TYPES.DECIMAL]: {
    value: ATTR_FORMAT_TYPES.DECIMAL,
    label: 'Decimal',
  },

  //Legacy Formats, keep around only for detection.
  [ATTR_FORMAT_TYPES.EMAIL]: {
    value: ATTR_FORMAT_TYPES.EMAIL,
    label: 'Email',
  },
  [ATTR_FORMAT_TYPES.IP]: {
    value: ATTR_FORMAT_TYPES.IP,
    label: 'IP Address',
  },
  [ATTR_FORMAT_TYPES.EPOCH]: {
    value: ATTR_FORMAT_TYPES.EPOCH,
    label: 'Epoch',
  },
  [ATTR_FORMAT_TYPES.SKU]: {
    value: ATTR_FORMAT_TYPES.SKU,
    label: 'SKU',
  },
  [ATTR_FORMAT_TYPES.CURRENCY]: {
    value: ATTR_FORMAT_TYPES.CURRENCY,
    label: 'Currency',
  },
  [ATTR_FORMAT_TYPES.NUMBER]: {
    value: ATTR_FORMAT_TYPES.NUMBER,
    label: 'Number',
  },
  [ATTR_FORMAT_TYPES.STRING]: {
    value: ATTR_FORMAT_TYPES.STRING,
    label: 'String',
  },
  [ATTR_FORMAT_TYPES.UPC]: {
    value: ATTR_FORMAT_TYPES.UPC,
    label: 'UPC',
  },
  [ATTR_FORMAT_TYPES.QUANTITY]: {
    value: ATTR_FORMAT_TYPES.QUANTITY,
    label: 'Quantity',
  },
};

export const VALIDATION_FORMAT_OPTIONS = [
  //raw type based
  {
    label: 'Array',
    value: { type: 'array' },
  },
  {
    label: 'Boolean',
    value: { type: 'boolean' },
  },
  {
    label: 'Integer',
    value: { type: 'integer' },
  },
  {
    label: 'Null',
    value: { type: 'null' },
  },
  {
    label: 'Number',
    value: { type: 'number' },
  },
  {
    label: 'Object',
    value: { type: 'object' },
  },
  {
    label: 'String',
    value: { type: 'string' },
  },
  // format based
  {
    label: 'Email',
    value: { format: ATTR_FORMAT_TYPES.EMAIL },
  },

  {
    label: 'IP v4',
    value: { format: ATTR_FORMAT_TYPES.IPV4 },
  },
  {
    label: 'IP v6',
    value: { format: ATTR_FORMAT_TYPES.IPV6 },
  },
  {
    label: 'User Agent',
    value: { format: ATTR_FORMAT_TYPES.USER_AGENT },
  },
  {
    value: { format: ATTR_FORMAT_TYPES.DEVICE_ID },
    label: 'Device Id',
  },
  {
    value: { format: ATTR_FORMAT_TYPES.LOCATION },
    label: 'Location',
  },
  {
    value: { format: ATTR_FORMAT_TYPES.VIN },
    label: 'VIN',
  },
  {
    value: { format: ATTR_FORMAT_TYPES.URL },
    label: 'URL',
  },
  {
    value: { format: ATTR_FORMAT_TYPES.CREDIT_CARD },
    label: 'Credit Card',
  },
  {
    value: { format: ATTR_FORMAT_TYPES.SSN },
    label: 'SSN',
  },
  {
    value: { format: ATTR_FORMAT_TYPES.HASH },
    label: 'Hash',
  },
  {
    value: { format: ATTR_FORMAT_TYPES.TIME },
    label: 'Time',
  },
  {
    value: { format: ATTR_FORMAT_TYPES.DATE },
    label: 'Date',
  },
  {
    value: { format: ATTR_FORMAT_TYPES.TIMESTAMP },
    label: 'Timestamp',
  },

  {
    value: { format: ATTR_FORMAT_TYPES.DECIMAL },
    label: 'Decimal',
  },
];
